module.exports = __webpack_public_path__ + "a58beaa8c10c887f5411be1578c93d33.svg";